import { useState } from "react";

export default function TicketTable({ title, data }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [sortKey, setSortKey] = useState("employee_name");
  const [sortOrder, setSortOrder] = useState("asc");

  const filteredData = data
    .filter(item =>
      item.Ticket_details.employee_name.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      const valA = a.Ticket_details[sortKey] || "";
      const valB = b.Ticket_details[sortKey] || "";
      return sortOrder === "asc"
        ? valA.localeCompare(valB)
        : valB.localeCompare(valA);
    });

  const handleSort = key => {
    if (sortKey === key) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortKey(key);
      setSortOrder("asc");
    }
  };

  return (
    <div className="bg-white shadow rounded-xl p-4 mb-6">
      <h2 className="text-xl font-semibold mb-4">{title}</h2>
      <input
        type="text"
        placeholder="Search by name"
        value={searchTerm}
        onChange={e => setSearchTerm(e.target.value)}
        className="border rounded px-3 py-1 mb-3 w-1/3"
      />
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm text-left">
          <thead className="bg-[#EF7320] text-white">
            <tr>
              {["employee_name", "employee_id", "ticket_type", "status", "creator", "employee_department"].map(col => (
                <th
                  key={col}
                  onClick={() => handleSort(col)}
                  className="px-4 py-2 cursor-pointer"
                >
                  {col.replace(/_/g, " ").toUpperCase()}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredData.map((item, idx) => (
              <tr key={idx} className="bg-gray-100 border-b">
                <td className="px-4 py-2">{item.Ticket_details.employee_name}</td>
                <td className="px-4 py-2">{item.Ticket_details.employee_id}</td>
                <td className="px-4 py-2">{item.Ticket_details.ticket_type}</td>
                <td className="px-4 py-2">{item.Ticket_details.status}</td>
                <td className="px-4 py-2">{item.Ticket_details.creator}</td>
                <td className="px-4 py-2">{item.Ticket_details.employee_department}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
